import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Typography, Box, Tab, Tabs, Container } from '@mui/material';
import { SiCplusplus, SiPython, SiJavascript, SiReact, SiDjango, SiLinux, SiGit, SiPostman, SiFlutter, SiNodedotjs } from 'react-icons/si';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

// Styled components
const SkillsContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

const TabContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginTop: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'space-around',
  },
}));

const SkillBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: 200,
  [theme.breakpoints.down('sm')]: {
    maxWidth: 120,
  },
}));

const IconWrapper = styled('div')(({ theme }) => ({
  '& > svg': {
    fontSize: '3rem',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.5rem',
    },
  },
}));

const ProgressBarBox = styled('div')(({ theme }) => ({
  width: '70%',
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const SkillsSection = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const skillsCategories = [
    {
      label: 'Languages',
      skills: [
        { icon: SiPython, level: 75, label: 'Python' },
        { icon: SiJavascript, level: 85, label: 'JavaScript' },
        { icon: SiCplusplus, level: 80, label: 'C/C++' },
      ],
    },
    {
      label: 'Tools',
      skills: [
        { icon: SiGit, level: 90, label: 'Git' },
        { icon: SiLinux, level: 80, label: 'Linux' },
        { icon: SiPostman, level: 70, label: 'Postman' },
      ],
    },
    {
      label: 'Frameworks',
      skills: [
        { icon: SiReact, level: 70, label: 'React.js' },
        { icon: SiNodedotjs, level: 40, label: 'Node.js' },
        { icon: SiFlutter, level: 40, label: 'Flutter' },
        { icon: SiDjango, level: 60, label: 'Django' },
      ],
    },
  ];

  return (
    <SkillsContainer id="skillsSection">
      <Tabs value={value} onChange={handleChange} centered>
        {skillsCategories.map((category, index) => (
          <Tab label={category.label} key={index} />
        ))}
      </Tabs>
      {skillsCategories.map((category, index) => (
        <Box role="tabpanel" hidden={value !== index} key={index}>
          {value === index && (
            <TabContent>
              {category.skills.map((skill, skillIndex) => (
                <SkillBox key={skillIndex}>
                  <IconWrapper>{React.createElement(skill.icon)}</IconWrapper>
                  <ProgressBarBox>
                    <CircularProgressbar
                      value={skill.level}
                      text={`${skill.level}%`}
                      styles={buildStyles({
                        pathColor: `rgba(62, 152, 199, ${skill.level / 100})`,
                        textColor: '#3e98c7',
                        trailColor: '#d6d6d6',
                        pathTransitionDuration: 0.5,
                        textSize: '16px',
                        strokeLinecap: 'butt',
                      })}
                    />
                  </ProgressBarBox>
                  <Typography variant="caption">{skill.label}</Typography>
                </SkillBox>
              ))}
            </TabContent>
          )}
        </Box>
      ))}
    </SkillsContainer>
  );
};

export default SkillsSection;
